<script lang="ts">import { afterUpdate, onDestroy, onMount } from "svelte";
import Swiper from "swiper";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/swiper-bundle.css";
import TopSectionContent from "./top-section-content.svelte";
let swiperContainer;
let swiper;
let initialized = false;
const initializeSwiper = () => {
	if (swiper) {
		swiper.destroy(true, true);
	}
	swiper = new Swiper(swiperContainer, {
		modules: [Autoplay, Pagination],
		autoplay: {
			delay: 5e3,
			disableOnInteraction: false
		},
		loop: true,
		spaceBetween: 12,
		slidesPerView: 1.05,
		slidesPerGroup: 1,
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
			type: "bullets"
		},
		breakpoints: {
			768: {
				slidesPerView: 2.05,
				slidesPerGroup: 1
			},
			1024: {
				slidesPerView: 3.05,
				slidesPerGroup: 1
			},
			1280: {
				slidesPerView: 3,
				slidesPerGroup: 1
			}
		}
	});
};
function onSlidesReady(count) {
	if (typeof window === "undefined") return;
	if (swiper) {
		requestAnimationFrame(() => swiper.update());
	} else {
		requestAnimationFrame(() => initializeSwiper());
	}
}
onMount(() => {
	if (!initialized) initializeSwiper();
});
afterUpdate(() => {
	if (swiper) {
		requestAnimationFrame(() => swiper.update());
	}
});
onDestroy(() => {
	if (swiper) swiper.destroy(true, true);
});
</script>

<div class="casino-top-section-desktop">
	<div class="swiper-container" bind:this={swiperContainer}>
		<div class="swiper-wrapper top-cards-swiper">
			<TopSectionContent onReady={onSlidesReady} />
		</div>
		<div class="swiper-controls-container">
			<div class="swiper-controls">
				<div class="swiper-pagination pagination-override" />
			</div>
		</div>
	</div>
</div>

<style>
	.casino-top-section-desktop {

		position: relative;

		height: auto;

		width: 100%;
}

	@media (min-width: 1024px) {
		.casino-top-section-desktop {

				display: flex;

				gap: 1rem;
		}
	}

	.swiper-container {

		display: flex;

		height: auto;

		width: 100%;

		flex-direction: column;

		overflow: hidden;

		-webkit-mask-image: linear-gradient(to right, black 0%, black 95%, transparent 99%);
		mask-image: linear-gradient(to right, black 0%, black 95%, transparent 99%);
		-webkit-mask-repeat: no-repeat;
		mask-repeat: no-repeat;
}

	@media (min-width: 1024px) {
		.swiper-container {
			-webkit-mask-image: linear-gradient(to right, black 0%, black 99.5%, transparent 99.9%);
			mask-image: linear-gradient(to right, black 0%, black 99.5%, transparent 99.9%);
			-webkit-mask-repeat: no-repeat;
			mask-repeat: no-repeat;
		}
	}

	@media (max-width: 1023px) {
		.swiper-container {
			width: calc(100% + 5vw);
			margin-left: -1vw;
			padding-left: 1vw;
			padding-right: 1vw;
		}
	}

	/*
	.swiper-slide {
		@apply flex justify-center items-center;
	}
	*/

	.swiper-controls-container {

		height: 40px;
}

	:global(.swiper-container .swiper-pagination-bullet) {

		background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
		height: 6px;
		width: 6px;
		--tw-bg-opacity: 1;
		background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
		opacity: 0.9;
		background-color: #7b8ac5 !important;
}

	:global(.swiper-container .swiper-pagination-bullet-active) {

		height: 6px;

		opacity: 1;
		width: 24px !important;
		border-radius: 25px !important;
		background-color: #7b8ac5;
		position: relative;
		overflow: visible;
}

	:global(.swiper-container .swiper-pagination-bullet-active::before) {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		width: 0;
		background-image: linear-gradient(
			180deg,
			var(--color-primary-500) 0%,
			var(--color-primary-500) 100%
		);
		animation: fillProgress 5s linear forwards;
		border-radius: 25px;
		box-shadow: 0px 0px 10px 0px var(--color-primary-500);
		z-index: 1;
	}

	:global(.swiper-container .swiper-pagination-bullet-active::after) {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		width: 100%;
		border-radius: 25px;
		background-color: transparent;
		z-index: 2;
	}

	@keyframes fillProgress {
		0% {
			width: 0;
		}
		100% {
			width: 100%;
		}
	}
</style>
